import { Component, Injector, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';
import { AttachmentsService } from '../services/attachments/attachments.service';
import { AttachmentResponse } from '../shared/model/attachment-response.model';
import { saveAs } from 'file-saver-es';
import { interval, Subscription } from 'rxjs';

@Component({
    templateUrl: './attachment-base.component.html'
})
export class AttachmentsBaseComponent extends BaseComponent implements OnInit {

    message: string;
    @Input() public publicationHistoryId: string;
    @Input() public submittalId: string;
    showMessage: boolean;
    messageClass: string;
    private _attachmentService: AttachmentsService;
    attachmentsModel: AttachmentResponse[] = [];
    progressBarValue = 0;
    public showProgressBar = false;
    subscription: Subscription;

    constructor(public _injector: Injector) {
        super(_injector);
        this._attachmentService = this._injector.get(AttachmentsService);
    }


    ngOnInit(): void {
        super.ngOnInit;
    }

    OpenAttachment(fileServiceId: string, fileName: string): void {
        if (this.IdExistsAndIsPDFWithFileName(fileServiceId, fileName)) {
            this.PreviewAttachment(fileServiceId);
        } else {
            this.downloadAttachment(fileServiceId);
        }
    }

    IdExistsAndIsPDFWithFileName(fileId: string, fileName: string): boolean {
        var fileType = fileName.substring(fileName.length - 3);
        return fileId !== undefined && fileType.toUpperCase() == 'PDF';
    }

    PreviewAttachment(fileServiceId: string): void {
        if (this.showProgressBar == false) {
            this.ShowProgressBar();
            this.showProgress();
            this._attachmentService.getPdfAttachment(fileServiceId).subscribe(res => {
                const fileURL = URL.createObjectURL(res);
                window.open(fileURL, '_blank');
                this.hideProgress();
                this.HideProgressBar();
            }, error => {
                this.toggleMessage('Error downloading attachment. Please contact System Administrator.', true, false);
                this.hideProgress();
                this.HideProgressBar();
            });
        }
    }

    downloadAttachment(fileServiceId: string): void {
        if (this.showProgressBar == false) {
            this.ShowProgressBar();
            this.showProgress();
            this._attachmentService.getAttachment(fileServiceId).subscribe(response => {
                const attachment = this.attachmentsModel.find(item => item.fileServiceId === fileServiceId);
                saveAs(response, attachment.fileName);
                this.hideProgress();
                this.HideProgressBar();
            }, error => {
                this.toggleMessage('Error downloading attachment. Please contact System Administrator.', true, false);
                this.hideProgress();
                this.HideProgressBar();
            });
        }
    }

    OpenFirstAttachment(publicationHistoryId: string, callback?: Action<any>) {
        if (publicationHistoryId != undefined) {
            this._attachmentService.GetAttachmentListByPublicationHistoryId(publicationHistoryId).subscribe(attachments => {
                this.attachmentsModel = attachments;
                this.OpenAttachment(attachments[0].fileServiceId, attachments[0].fileName);
            }, error => {
                this.toggleMessage('Error downloading attachment. Please contact System Administrator.', true, false);
                this.hideProgress();
            });
        }
        callback;
    }

    private HideProgressBar() {
        this.progressBarValue = 100;
        this.showProgressBar = false;
        this.subscription.unsubscribe();
    }

    private ShowProgressBar() {
        this.showProgressBar = true;
        this.progressBarValue = 20;
        // emit value in sequence every 1 second
        const source = interval(1000);
        this.subscription = source.subscribe(val => this.IncreaseProgressValue(1));
    }

    IncreaseProgressValue(value: number): void {
        this.progressBarValue = this.progressBarValue + value;
        if (this.progressBarValue > 99)
            this.progressBarValue = 20;
    }

    OpenFirstSubmittalAttachment(submittalId: any, callback?: Action<any>) {
        if (submittalId != undefined) {
            this._attachmentService.GetAttachmentListBySubmittalId(submittalId).subscribe(attachments => {
                this.attachmentsModel = attachments;
                this.OpenAttachment(attachments[0].fileServiceId, attachments[0].fileName);
                callback;
            }, error => {
                this.toggleMessage('Error downloading attachment. Please contact System Administrator.', true, false);
                this.hideProgress();
            });
        }
    }

    LoadAttachments() {
        if (this.submittalId != undefined) {
            this._attachmentService.GetAttachmentListBySubmittalId(this.submittalId).subscribe(attachments => {
                this.attachmentsModel = attachments;
            })
        }

        if (this.publicationHistoryId != undefined) {
            this._attachmentService.GetAttachmentListByPublicationHistoryId(this.publicationHistoryId).subscribe(attachments => {
                this.attachmentsModel = attachments;
            })
        }
    }

    toggleMessage(message: string, showMessage: boolean, isSuccess: boolean, dismissOnTimeout: boolean = true): void {
        this.message = message;
        this.showMessage = showMessage;
        this.messageClass = isSuccess ? 'alert alert-success' : 'alert alert-danger';

        if (dismissOnTimeout) {
            setTimeout(x => this.showMessage = false, 5000);
        }
    }
}
export type Action<T> = (item: T) => void;